package com.example.positionahead.model

data class PricePoint(
    val date: String,
    val close: Double,
)

data class SymbolPriceHistory(
    val symbol: String,
    val points: List<PricePoint>,
)

data class PortfolioPriceHistory(
    val points: List<PricePoint>,
    val changePercent: Double?,
)
